import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=4b2c414d"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"
import style0 from "./ai.vue?vue&type=style&index=0&id=4b2c414d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports